import { useEffect } from 'react'

const SELECTOR = '.reveal, .reveal-left, .reveal-right'

function markVisible(el) {
  el.classList.add('visible')
}

/** Force all elements currently in the viewport to become visible */
function checkInViewport() {
  const vh = window.innerHeight
  document.querySelectorAll(SELECTOR).forEach((el) => {
    const rect = el.getBoundingClientRect()
    if (rect.top < vh * 0.96 && rect.bottom > 0) {
      markVisible(el)
    }
  })
}

export function useReveal() {
  useEffect(() => {
    const observed = new WeakSet()

    // IntersectionObserver — très généreux pour ne rater aucun élément
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) markVisible(entry.target)
        })
      },
      { threshold: 0.04, rootMargin: '0px 0px -10px 0px' }
    )

    function observeEl(el) {
      if (!observed.has(el)) {
        observed.add(el)
        io.observe(el)
      }
    }

    // Observer tous les éléments déjà dans le DOM
    document.querySelectorAll(SELECTOR).forEach(observeEl)

    // MutationObserver — attrape les éléments ajoutés après chargement API
    const mo = new MutationObserver(() => {
      document.querySelectorAll(SELECTOR).forEach(observeEl)
      checkInViewport()
    })
    mo.observe(document.body, { childList: true, subtree: true })

    // Vérifications initiales décalées (les composants async ont le temps de render)
    checkInViewport()
    const t1 = setTimeout(checkInViewport, 200)
    const t2 = setTimeout(checkInViewport, 600)
    const t3 = setTimeout(checkInViewport, 1500)

    // Scroll passif comme filet de sécurité
    window.addEventListener('scroll', checkInViewport, { passive: true })

    // Hash/anchor navigation
    const onHashChange = () => {
      setTimeout(checkInViewport, 100)
      setTimeout(checkInViewport, 600)
    }
    window.addEventListener('hashchange', onHashChange)

    // Exposé pour que Navbar puisse l'appeler après scroll programmatique
    window.__revealCheck = checkInViewport

    return () => {
      io.disconnect()
      mo.disconnect()
      clearTimeout(t1)
      clearTimeout(t2)
      clearTimeout(t3)
      window.removeEventListener('scroll', checkInViewport)
      window.removeEventListener('hashchange', onHashChange)
      delete window.__revealCheck
    }
  }, [])
}
